module.exports = __webpack_public_path__ + "static/langojango-mandarin-language-phrasebook-ee23584ea0035f5dc80e79b68fec3abf.png";